import { ChangeEvent, Ref } from "react";
import { Flex, FlexProps } from "./Flex";
import { Icon } from "./Icon";
import { InputFile } from "./InputFile";
import { Span } from "./Span";
import { Spinner } from "./Spinner";

interface UploadFileInput {
  isUploading: boolean;
  file: File | null;
  resetFile: () => void;
  accept: string[];
  width: FlexProps["width"];
  fileRef: Ref<HTMLInputElement>;
  onFileChange: (e: ChangeEvent<HTMLInputElement>) => Promise<void>;
  text?: React.ReactNode;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  id?: string;
  disabled?: boolean;
}

export const UploadFileInput: React.FC<UploadFileInput> = ({
  file,
  isUploading,
  width,
  resetFile,
  accept,
  fileRef,
  onFileChange,
  text,
  onBlur,
  id,
  disabled,
}) => {
  return (
    <>
      <InputFile
        accept={accept.join(",")}
        ref={fileRef}
        border={file !== null ? "green" : "primary"}
        onChange={onFileChange}
        width={width}
        onBlur={onBlur}
        id={id}
        disabled={disabled}
      >
        <Flex
          width={width}
          direction="col"
          items="center"
          gap={4}
          style={{ overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {isUploading ? (
            <Flex width={40} direction="col" items="center">
              <Spinner size={20} />
            </Flex>
          ) : file === null ? (
            <Flex direction="row" items="center" gap={0}>
              <Span neutral={true}>
                <Icon name="upload" primary size={16} />
              </Span>

              <Span black={true} size="sm" primary>
                Upload
              </Span>
            </Flex>
          ) : (
            <Flex width={40} direction="row" justify="center">
              <Span green={true}>
                <Icon name="document-plus" size={50} />
              </Span>
            </Flex>
          )}
        </Flex>
      </InputFile>
      <Flex
        direction="col"
        items="start"
        justify="between"
        horizontalPadding={0}
        verticalMargin={0}
        width={width}
        gap={1}
        className="w-full-important mt-2.5"
      >
        <Span style={{ padding: 0 }} italic font="medium" size="sm">
          {text}
        </Span>
        <Flex gap={2} width={width} height={6}>
          {file !== null ? (
            <>
              <Span style={{ padding: 0, width: "20px" }} className={"cursor-pointer"}>
                {!isUploading ? (
                  <Icon
                    name="x"
                    primary
                    fill={isUploading ? "gray" : "black"}
                    onClick={
                      isUploading
                        ? undefined
                        : () => {
                            if (fileRef) {
                              // @ts-expect-error (this is the way how to reset the FileInput in React)
                              fileRef.current.value = null;
                            }
                            resetFile();
                          }
                    }
                  />
                ) : null}
              </Span>
              <Span
                style={{ padding: 0, overflow: "hidden", textOverflow: "ellipsis" }}
                green={!isUploading}
                font="medium"
                size="sm"
              >
                {file.name}
              </Span>
            </>
          ) : null}
        </Flex>
      </Flex>
    </>
  );
};
